import { types } from './resourcesActions';

const initialState = {
    pending: false,
    payload: {},
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.HTTP_PENDING_RESOURCES:
            return {
                ...state,
                pending: true
            }
        case types.HTTP_SUCCESS_RESOURCES:
            return {
                ...state,
                pending: false,
                payload: action.payload
            }

        case types.HTTP_ERROR_RESOURCES:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}

